class UgcPostCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-ugc-track]');
    this.dots = this.querySelector('[data-ugc-dots]');
    if (!this.track) return;
    this.observeVideos();
    this.slides = [...this.track.children];
    if (this.slides.length < 2) return;
    this.dots.hidden = false;
    const label = this.dataset.dotLabel || 'Image';
    this.dots.replaceChildren(
      ...this.slides.map((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ugc-gallery__dot';
        dot.setAttribute('aria-label', `${label} ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        return dot;
      })
    );
    this.track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      },
      { passive: true }
    );
    this.update();
  }

  observeVideos() {
    const videos = this.track.querySelectorAll('video');
    if (!videos.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach((video) => video.play().catch(() => {}));
      return;
    }
    this.videoObserver = new IntersectionObserver(
      (entries) => entries.forEach((entry) => (entry.isIntersecting ? entry.target.play().catch(() => {}) : entry.target.pause())),
      { threshold: 0.5 }
    );
    videos.forEach((video) => this.videoObserver.observe(video));
  }

  disconnectedCallback() {
    this.videoObserver?.disconnect();
  }

  goTo(index) {
    const slide = this.slides[index];
    if (!slide) return;
    const offset = slide.offsetLeft;
    this.track.scrollTo({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }

  update() {
    const left = this.track.getBoundingClientRect().left;
    let index = 0;
    let best = Infinity;
    this.slides.forEach((slide, i) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - left);
      if (distance < best) {
        best = distance;
        index = i;
      }
    });
    [...this.dots.children].forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
  }
}

if (!customElements.get('ugc-post-carousel')) customElements.define('ugc-post-carousel', UgcPostCarousel);
